export default class Guest {
    constructor(parent) {
        this.parent = parent;
        this.modal = this.parent.parent;
        this.el = parent.el.querySelector('.guest-content');
        this.button = this.el.querySelector('.guest-button');
        this.bind();
    }

    bind() {
        this.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.modal.hide();
        });
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
